<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card class="box">
      <v-data-table
        :headers="headers"
        :items="feedback_version_list"
        dense
        class="elevation-1 mytable"
        :search="search"
      >
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Feedback Version</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <span style="width: 20px"> </span>
          <v-row justify="center" dense>
            <v-col sm="3" md="1" cols="12"> </v-col>
            <v-col sm="6" md="4" cols="12">
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-col>

            <span style="width: 20px"> </span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="mb-2 button" v-on="on" small
                  >Add Feedback Version</v-btn
                >
              </template>
              <v-card>
                <v-form v-model="valid">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col sm="6" v-if="editedIndex == -1">
                          <v-autocomplete
                            :items="ay_list"
                            v-model="addedItem.ay"
                            label="Select Academic Year"
                            :rules="[(v) => !!v || 'required']"
                          ></v-autocomplete>
                        </v-col>

                        <v-col sm="6" v-if="editedIndex != -1">
                          <v-autocomplete
                            :items="ay_list"
                            v-model="editedItem.ay"
                            label="Select Academic Year"
                            :rules="[(v) => !!v || 'required']"
                          ></v-autocomplete>
                        </v-col>

                        <v-col sm="6" v-if="editedIndex == -1">
                          <v-autocomplete
                            :items="alL_feedback_type"
                            v-model="addedItem.name"
                            label="Select Feedback Type"
                            :rules="[(v) => !!v || 'required']"
                          ></v-autocomplete>
                        </v-col>

                        <v-col sm="6" v-if="editedIndex != -1">
                          <v-autocomplete
                            :items="alL_feedback_type"
                            v-model="editedItem.name"
                            persistent-hint
                            :rules="[(v) => !!v || 'required']"
                            label="Feedback Question Type"
                          ></v-autocomplete>
                        </v-col>

                        <v-col sm="6" v-if="editedIndex == -1">
                          <v-text-field
                            v-model="addedItem.title"
                            persistent-hint
                            :rules="[(v) => !!v || 'required']"
                            label="Feedback Title"
                          ></v-text-field>
                        </v-col>

                        <v-col sm="6" v-if="editedIndex != -1">
                          <v-text-field
                            v-model="editedItem.title"
                            persistent-hint
                            :rules="[(v) => !!v || 'required']"
                            label="Feedback Title"
                          ></v-text-field>
                        </v-col>

                        <v-col sm="6" v-if="editedIndex == -1">
                          <v-text-field
                            type="number"
                            v-model="addedItem.feedback_no"
                            persistent-hint
                            :rules="[(v) => !!v || 'required']"
                            label="Feedback Number"
                          ></v-text-field>
                        </v-col>

                        <v-col sm="6" v-if="editedIndex != -1">
                          <v-text-field
                            type="number"
                            v-model="editedItem.feedback_no"
                            persistent-hint
                            :rules="[(v) => !!v || 'required']"
                            label="Feedback Number"
                          ></v-text-field>
                        </v-col>

                        <v-col sm="6" v-if="editedIndex == -1">
                          <v-menu
                            ref="menu2"
                            v-model="menu2"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            full-width
                            max-width="290px"
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                dense
                                rounded
                                v-model="dateFormatted"
                                :rules="
                                  dateFormatted == null || dateFormatted == ''
                                    ? [' Date is required']
                                    : []
                                "
                                label="From Date *"
                                hint="DD/MM/YYYY format"
                                persistent-hint
                                outlined
                                @blur="date2 = parseDate(dateFormatted)"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="date2"
                              no-title
                              @input="menu2 = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col sm="6" v-if="editedIndex != -1">
                          <v-menu
                            ref="menu2_edit"
                            v-model="menu2_edit"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            full-width
                            max-width="290px"
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                dense
                                rounded
                                v-model="dateFormatted_edit"
                                label="From Date *"
                                hint="DD/MM/YYYY format"
                                persistent-hint
                                outlined
                                @blur="
                                  date2_edit = parseDate(dateFormatted_edit)
                                "
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="date2_edit"
                              no-title
                              @input="menu2_edit = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>

                        <v-col sm="6" v-if="editedIndex == -1">
                          <v-menu
                            ref="menu1"
                            v-model="menu1"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            full-width
                            max-width="290px"
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                dense
                                rounded
                                v-model="dateFormatted_end"
                                :rules="
                                  dateFormatted_end == null ||
                                  dateFormatted_end == ''
                                    ? [' Date is required']
                                    : []
                                "
                                label="End Date *"
                                hint="DD/MM/YYYY format"
                                persistent-hint
                                outlined
                                @blur="date2_end = parseDate(dateFormatted_end)"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="date2_end"
                              no-title
                              @input="menu1 = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col sm="6" v-if="editedIndex != -1">
                          <v-menu
                            ref="menu1_edit"
                            v-model="menu1_edit"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            full-width
                            max-width="290px"
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                dense
                                rounded
                                v-model="edit_dateFormatted_end"
                                label="End Date"
                                hint="DD/MM/YYYY format"
                                persistent-hint
                                outlined
                                @blur="
                                  edit_dateFormatted_end = parseDate(
                                    edit_dateFormatted_end
                                  )
                                "
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="edit_date2_end"
                              no-title
                              @input="menu1_edit = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>

                        <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                          <v-checkbox
                            dense
                            v-model="editedItem.isactive"
                            color="success"
                            label="Active"
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="mb-2 button" text @click="close"
                      >Cancel</v-btn
                    >
                    <v-btn class="mb-2 button" @click="save" :disabled="!valid"
                      >Save</v-btn
                    >
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </template>

        <template v-slot:item.isactive="{ item }">
          <span v-if="item.isactive">
            <v-icon class="mr-2 v-icon-size" color="success"
              >mdi-check-circle-outline</v-icon
            >
          </span>
          <span v-else>
            <v-icon class="mr-2 v-icon-size" color="error"
              >mdi-close-circle-outline</v-icon
            >
          </span>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)"
                >edit</v-icon
              >
            </v-avatar>
          </div>
          <!-- <v-icon
        small
        @click="deleteItem(item)"
      >
        delete
      </v-icon>-->
        </template>
        <!-- <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template>-->
      </v-data-table>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data: () => ({
    valid: false,
    overlay: false,
    errorMsg: {
      roomtype: false,
    },
    menu2: false,
    menu2_edit: false,
    menu1: false,
    menu1_edit: false,
    display_size: null,
    dateFormatted_edit: "",
    edit_dateFormatted_end: "",
    dateFormatted: "",
    dateFormatted_end: "",
    date2: new Date().toISOString().substr(0, 10),
    date2_edit: "",
    date2_end: new Date().toISOString().substr(0, 10),
    edit_date2_end: "",
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    ay_list: null,
    alL_feedback_type: null,
    feedback_version_list: null,
    headers: [
      {
        text: "Sr No",
        align: "left",
        sortable: false,
        value: "sr_no",
      },
      {
        text: "Academic Year",
        align: "left",
        sortable: false,
        value: "ay",
      },
      {
        text: "Feedback Type",
        align: "left",
        sortable: false,
        value: "name",
      },
      {
        text: "Feedback title",
        align: "left",
        sortable: false,
        value: "title",
      },
      {
        text: "Feedback No",
        align: "left",
        sortable: false,
        value: "feedback_no",
      },
      {
        text: "Start Date",
        align: "left",
        sortable: false,
        value: "fromDate",
      },
      {
        text: "End Date",
        align: "left",
        sortable: false,
        value: "endDate",
      },
      {
        text: "Active",
        align: "left",
        sortable: true,
        value: "isactive",
      },

      { text: "Actions", value: "action", sortable: false },
    ],
    feedback_version_list: [],
    editedIndex: -1,
    addedItem: {
      id: "",
      ay: "",
      name: "",
      feedback_no: "",
      title: "",
      date2: "",
      date2_end: "",
      isactive: true,
    },
    editedItem: {
      id: "",
      ay: "",
      name: "",
      feedback_no: "",
      title: "",
      edit_dateFormatted_end: "",
      dateFormatted_edit: "",
      isactive: true,
    },
    defaultItem: {
      id: "",
      ay: "",
      name: "",
      feedback_no: "",
      title: "",
      date2: "",
      date2_end: "",
      isactive: true,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New Feedback Version"
        : "Edit Feedback Version";
    },
  },
  watch: {
    date2(val) {
      this.dateFormatted = this.formatDate(this.date2);
    },
    date2_end(val) {
      this.dateFormatted_end = this.formatDate(this.date2_end);
    },
    date2_edit(val) {
      this.dateFormatted_edit = this.formatDate(this.date2_edit);
    },
    edit_date2_end(val) {
      this.edit_dateFormatted_end = this.formatDate(this.edit_date2_end);
    },

    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },
  // created () {
  //   this.initialize()
  // },
  mounted() {
    this.onLoad();
  },

  methods: {
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    initializeErrorMsgFalse() {
      this.errorMsg.roomtype = false;
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/Feedback/getFeedbackVersion")
        .then((res) => {
          if (res.data.msg == "200") {
            //window.alert(res.data.msg)
            console.log(res.data.msg);
            if ((this.load = true)) {
              this.overlay = false;
              this.ay_list = res.data.ay_list;
              this.alL_feedback_type = res.data.alL_feedback_type;
              this.feedback_version_list = res.data.feedback_version_list;
              // alert(JSON.stringify(this.feedback_version_list))
            }
          } else {
            window.console.log(res.data.msg);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          "use strict";
          var overlay = false;
        });
        //alert(JSON.stringify(this.feedback_version_list))
    },
    editItem(item) {
      this.editedIndex = this.feedback_version_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.edit_dateFormatted_end=this.editedItem.endDate
      this.dateFormatted_edit=this.editedItem.fromDate
      this.dialog = true;
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    close() {
      this.addedItem.title = null;
      this.addedItem.ay = null;
      this.addedItem.name = null;
      this.addedItem.feedback_no = null;
      this.dateFormatted = null
      this.dateFormatted_end= null
      this.dialog = false;
      this.initializeErrorMsgFalse();
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          const formData2 = {
            id: this.editedItem.id,
            name: this.editedItem.name,
            ay: this.editedItem.ay,
            title: this.editedItem.title,
            feedback_no: this.editedItem.feedback_no,
            isactive: this.editedItem.isactive,
            fromDate: this.dateFormatted_edit,
            endDate: this.edit_dateFormatted_end
        };
          axios
            .post("/Feedback/editFeedbackVersion", formData2)
            .then((res) => {
              if (res.data.status.code == "SUCCESS") {
                Object.assign(
                  this.feedback_version_list[this.editedIndex],
                  
                );
                
                this.showSnackbar(
                  "#4caf50",
                  "Feedback Type Updated Successfully..."
                );
                this.onLoad();
                // show snackbar on success
              } else {
                this.showSnackbar(
                  "#b71c1c",
                  "Feedback Type Already Present!!!"
                );
              }
              //alert(JSON.stringify(this.feedback_version_list))
            })
            .catch((error) => {
              window.console.log(error);
            })
            
          this.close();
        }
      } else {
        const formData = {
          id: this.addedItem.id,
          name: this.addedItem.name,
          ay: this.addedItem.ay,
          title: this.addedItem.title,
          feedback_no: this.addedItem.feedback_no,
          fromDate: this.dateFormatted,
          endDate: this.dateFormatted_end,
        };
        //alert(formData.fromDate +" "+ formData.endDate)
        axios
          .post("/Feedback/saveFeedbackVersion", formData)
          .then((res) => {
            if (res.data.status.code == "SUCCESS") {
              this.feedback_version_list.push(this.addedItem);
              this.showSnackbar(
                "#4caf50",
                "Feedback Version Added Successfully!!!"
              ); // show snackbar on success
              this.onLoad();
            } else if (res.data.status.code == "NA") {
              this.showSnackbar(
                "#b71c1c",
                "Feedback Version Already Present!!!"
              ); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          })
          .finally(() => {
            this.addedItem.title = null;
            this.addedItem.ay = null;
            this.addedItem.name = null;
            this.addedItem.feedback_no = null;
            this.dateFormatted = null;
            this.dateFormatted_end = null;
          });
        this.close();
      }
    }, //save()
    isValidated() {
      // alert('I am in isValidated()'+this.editedItem.name +"||" +this.editedItem.usertype.id +"||"+this.editedItem.roletype.id)
      if (this.editedItem.name) {
        return true;
      } else {
        if (!this.editedItem.name) {
          this.errorMsg.name = true;
        }

        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
.mytable /deep/ thead th {
  background: #0f2027; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
</style>
